(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_warranty-accordion"] && !Shopify.designMode) return;
  try {
    class WarrantyAccordion extends HTMLElement {
    connectedCallback() {
      this.#syncCloseOthers();
    }

    #syncCloseOthers() {
      const closeOthers = this.hasAttribute('data-close-others');

      this.querySelectorAll('accordion-custom').forEach((accordion) => {
        if (closeOthers) {
          accordion.setAttribute('close-other-accordions-on-click', '');
        } else {
          accordion.removeAttribute('close-other-accordions-on-click');
        }
      });
    }
  }

  if (!customElements.get('warranty-accordion')) {
    customElements.define('warranty-accordion', WarrantyAccordion);
  }
  } catch(e) { console.error(e); }
})();

})();
